import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'custom-chart',
  templateUrl: './custom-chart.component.html',
  styleUrls: ['./custom-chart.component.scss']
})
export class CustomChartComponent implements OnInit {

  @Input() goalValue: number = 0;
  @Input() achievedValue: number = 0;
  @Input() title: string = '';
  @Input() isCurrency: boolean = false;
  @Input() goalValueClass: string = '';
  @Input() achievedValueClass: string = '';

  percentage: number = 0;

  constructor() { }

  ngOnInit(): void {
    if(this.achievedValue > this.goalValue)
      this.percentage = 100;
    else{
      this.percentage = Number(((this.achievedValue / this.goalValue) * 100).toFixed(0));
    }
  }

}
